<template>
  <div>
    <vue-headful
      title="About"
      description="Mathew Moose - Software Engineer. This is a portfolio site used to showcase some of my work."
    />
    <section class="section">
      <div class="columns is-multiline">
        <div class="column is-6-desktop is-12-tablet">
          <div style="margin-bottom: 1.5rem">
            <h1 class="title">About Mathew</h1>
            <img :src="require('@/assets/Photo.png')"/>
            <p>
              I have an in-depth background of the core concepts of computer science such as algorithms, data structures, and architectures. This translates to a foundational skillset that can be applied in all areas within the field. I couple this with a knack for natural problem solving and a thirst for knowledge. I have been utilizing some of the latest frameworks, libraries, and packages in order to develop software.
            </p>
          </div>
          <div class="columns">
            <div class="column is-3">
              <font-awesome-icon :icon="['fal', 'globe']" size='3x' class="fa-icon"/>
              <p class="has-text-centered">Experience working with small groups, large teams, and external parties from all around the world.</p>
            </div>
            <div class="column is-3">
              <font-awesome-icon :icon="['fal', 'fire']" size='3x' class="fa-icon"/>
              <p class="has-text-centered">Extremely passionate about the work that I do and the people that I impact. I strive to have the absolute best quality with my work.</p>
            </div>
            <div class="column is-3">
              <font-awesome-icon :icon="['fal', 'graduation-cap']" size='3x' class="fa-icon"/>
              <p class="has-text-centered">Graduated with a B.S. in Computer Science and minor in Mathematics from the University of Pittsburgh at Johnstown in December of 2017.</p>
            </div>
            <div class="column is-3">
              <font-awesome-icon :icon="['far', 'star']" size='3x' class="fa-icon"/>
              <p class="has-text-centered">Member of both the <a href="https://www.phikappaphi.org/" target="_blank">Honor Society of Phi Kappa Phi</a> as well as the <a href="https://www.phietasigma.org/" target="_blank">Phi Eta Sigma National Honor Society</a>.</p>
            </div>
          </div>
        </div>
        <div class="column is-6-desktop is-12-tablet">
          <tag-canvas></tag-canvas>
        </div>
      </div>
    </section>

  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .fa-icon{
    color: cyan;
    margin-bottom: 5px;
  }
  a {
    color: cyan;
    text-decoration: none;
  }
</style>
<script>
import TagCanvas from '@/components/TagCanvas.vue'
export default {
  components: { 'tag-canvas': TagCanvas },
  name: 'About',
  data: function () {
    return {
      msg: 'About Mathew'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AboutPage.vue